import { ICAMSKey, FeatureType, TextPack } from "../Models/UtilityModels";
import * as events from '../Bus/Bus';
import { ReportModel, SystemType } from "../../Reports/ReportsModels";
import * as toastr from "toastr";
import { Utilities, ModalAction } from "./Utilities";
import { ModalPrompts, PredefinedModalEnum } from "./ModalPrompts";

export enum jqc {
    placeholder_for_promptModals = '#placeholder-for-promptModals',
    promptYesNoModal = '#promptYesNoModal',
    promptModalYesBtn = '#promptModalYesBtn',
    promptModalNoBtn = '#promptModalNoBtn'
}

export class Popovers {
    
    // PUBLIC Functions
    static showEditFormPopover = (el: any, data: ICAMSKey, parentModalID: string): void => {
        let parentModal: any = null;
        if (parentModalID != null) parentModal = $('#' + parentModalID);

        // Bind events when the popover is shown
        el.off("show.bs.popover");
        el.on("show.bs.popover", function () {
            //$($(this).data("bs.popover").getTipElement()).css("max-width", "400px");
        });

        el.off("shown.bs.popover");
        el.on("shown.bs.popover", function () {
            //$(".popover-close-btn").click(function () {
            //    el.popover("hide");
            //});

            // Set popover content
            let popoverEl = $('[data-popper-reference-hidden]');
            let popoverBody = popoverEl.find(".popover-body");
            if (popoverBody.length == 0) {
                var tmpEl = document.createElement("div");
                $(tmpEl).addClass("popover-body");
                popoverEl.append(tmpEl);
                popoverBody = popoverEl.find(".popover-body");
            }
            popoverEl.find(".popover-header").html(popoverTitleDiv);

            //Utilities.BlockUI($(".popover"));
            popoverBody.load(window.G_SITEFOLDERNAME + '/Utility/EditFormOptionsList', { data: data }, function (response, status, xhr) {
                //Utilities.UnBlockUI($(".popover"));
                if (xhr.status === 401) {//redirect to login in unauthorised
                    window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                }

                // Bind rows
                $('[data-editformoption-map]').on("click", function () {
                    el.popover("hide");

                    if (data.wkt == null) {
                        toastr.error("Error! The feature does not have any geometry.");
                    }
                    else {
                        events.bus.publish(events.eventZoomToAnyFeature([data, true, null]));
                    }
                    if (parentModal != null) parentModal.modal('hide');
                });

                // Bind rows
                var showRedraw = el.data("showredraw");
                if (showRedraw == false){
                    $('[data-editformoption-redraw]').hide();
                }
                else {
                    $('[data-editformoption-redraw]').on("click", function () {
                        const self = this;
                        el.popover("hide");

                        ModalPrompts.OpenPrompt({ promptYesNoPredefinedEnum: PredefinedModalEnum.GeomRedraw }).then(r => {
                            if (r.yes == true) {
                                doRedraw();
                            }
                            else {
                            }
                        }).catch(e => { });

                        function doRedraw() {
                            if (data.parentCode != null) {
                                events.bus.publish(events.eventZoomToAnyFeature([{ code: data.parentCode, featureType: data.parentFeatureType }, true, function (f) {
                                    events.bus.publish(events.eventNewMapGeometryReDraw([data, f]));
                                }]));
                            }
                            else if (data.wkt != null) {
                                events.bus.publish(events.eventZoomToAnyFeature([data, true, function (f) {
                                    events.bus.publish(events.eventNewMapGeometryReDraw([data, null])); // DO NOT pass the feature through
                                }]));
                            }
                            else {
                                events.bus.publish(events.eventNewMapGeometryReDraw([data, null]));
                            }

                        }
                        if (parentModal != null) parentModal.modal('hide');
                    });
                }
                

                $('[data-editformoption-copyurl]').on("click", function () {
                    el.popover("hide");

                    var link = el.data("sharelink");
                    (navigator as any).clipboard.writeText(link).then(() => {
                        Utilities.GetTranslations([{ textPack: TextPack.SelectListTextPack, key: "CopyUrlTitleTextResult" }]).then(m => { if (m.success == true) toastr.info(m.data[0].value); else toastr.info("Copied URL to clipboard!"); });
                    }, () => {
                        toastr.error("Failed to copy URL to clipboard!");
                    });
                });

                $('[data-editformoption-report]').on("click", function () {
                    el.popover('dispose');

                    if (parentModal != null) parentModal.modal('hide');

                    let reportModel: ReportModel = { promptForMap: true};

                    switch (data.featureType) {
                        case FeatureType.Maint:
                            reportModel.systemType = SystemType.OfficerMap_RecordList_Maint_Single;
                            break;
                        case FeatureType.Infra:
                            reportModel.systemType = SystemType.OfficerMap_RecordList_Infra_Single;
                            break;
                        case FeatureType.Route:
                            reportModel.systemType = SystemType.OfficerMap_RecordList_Route_Single;
                            break;
                        case FeatureType.Land:
                            reportModel.systemType = SystemType.OfficerMap_RecordList_Land_Single;
                            break;
                        case FeatureType.Contact:
                            reportModel.systemType = SystemType.Contact_RecordList_Single;
                            break;
                        case FeatureType.LegalEvent:
                            reportModel.systemType = SystemType.LegalEvents_Single;
                            break;
                        default:
                            break;
                    }

                    var selectedMsg = "Selected Record Only (1)";
                    reportModel.reportParameters = [{ name: "codes", values: [data.code] }];
                    events.bus.publish(events.eventOpenReportOrSelectList([reportModel, selectedMsg]));
                });

                $('[data-editformoption-audit]').on("click", function () {
                    el.popover('dispose');
                    setTimeout(function () { events.bus.publish(events.eventOpenAuditPopover([el, data])); }, 300);
                });

            });

        });

        // Create and show the popover
        let popoverTitleDiv =
            "<div class='d-flex justify-content-between'>" +
            "<div class='p'>Options</div>" +
            "</div>";
        el.attr('data-original-title', popoverTitleDiv);

        el.popover({
            html: true,
            toggle: 'popover',
            trigger: 'click',
            title: popoverTitleDiv,
            content: "Loading..."
            //content: function () {
            //    var el: any = document.createElement("div");
            //    //el.innerHTML = "Retreiving data...";
            //    return el;
            //}
        });
        el.popover('show');
    }
}






